import axios from "axios";

const URL = "https://gateway.hyundaicolombia.co/";

export const FinanceAll = async () => {
  return await axios.get(URL + "finance/all");
};

export const FinanceOne = async (category: any, slug: any) => {
  return await axios.post(URL + `finance/one`, { category, slug });
};

